/** Exact OSM segments in the reviewed upper Planai core, checked against the
 * operator's numbered 2026 routes. These are six segments of an advanced
 * descent, not six distinct runs or a complete intermediate Rookie route.
 * Geometry remains OSM; no restricted operator GPX coordinates are reused.
 */
export const PLANAI_CORE_TRAILS = ([
  [909668118, "403 - Pro Downhill", "advanced", "Black (difficult)", "Pro-Downhill_tour_7164"],
  [909668116, "403 - Pro Downhill", "advanced", "Black (difficult)", "Pro-Downhill_tour_7164"],
  [909668115, "404 - Rookie Downhill", "intermediate", "Red (moderate)", "Rookie-Downhill_tour_7133"],
  [1306351861, "403 - Pro Downhill", "advanced", "Black (difficult)", "Pro-Downhill_tour_7164"],
  [1306351862, "403 - Pro Downhill", "advanced", "Black (difficult)", "Pro-Downhill_tour_7164"],
  [909668114, "403 - Pro Downhill", "advanced", "Black (difficult)", "Pro-Downhill_tour_7164"],
] as const).map(([id, name, difficulty, label, page]) => ({
  osmId: `way/${id}`, name, difficulty,
  label, source: "Planai", sourceUrl: `https://www.planai.at/en/activities/hiking/${page}`,
  verifiedOn: "2026-09-08",
}));
